// The Xero sales accounts the office can bill a one-off draft invoice to (Session AQF).
//
// A CLIENT MIRROR, never a second home: the codes belong to XERO_ACCOUNTS in
// server/src/integrations/xero/accounts.ts, which was verified against ELE's live chart of accounts
// on 21 June 2026, and xeroSalesAccounts.parity.test.ts fails if this list and that map ever
// disagree in either direction. What lives HERE and nowhere else is the office-facing LABEL: the
// server map has keys, not words a person reads.
//
// The labels follow the names the accounts carry in Xero, so the office and the bookkeeper are
// talking about the same thing, and the code is shown alongside for the same reason. There is
// deliberately no default: an ad-hoc charge has no obvious account, and a default would quietly file
// revenue in the wrong place rather than ask.
export interface XeroSalesAccountOption {
  code: string;
  label: string;
}

export const XERO_SALES_ACCOUNT_OPTIONS: XeroSalesAccountOption[] = [
  { code: "201", label: "Call out" },
  { code: "202", label: "Servicing" },
  { code: "203", label: "Modernisation" },
  { code: "207", label: "Labour" },
  { code: "208", label: "Parts" },
  { code: "211", label: "Works by a third party" },
];

// "Labour (207)" -- what the picker shows for one account.
export function xeroSalesAccountLabel(code: string): string {
  const found = XERO_SALES_ACCOUNT_OPTIONS.find((a) => a.code === code);
  return found ? `${found.label} (${found.code})` : code;
}
